import { BsBadgeAd, BsBadgeHd, BsBroadcastPin, BsGraphUp, BsHddNetwork, BsMegaphone, BsPeople, BsPhone} from "react-icons/bs";

const ServicesData = {
  advService: [
    {
      id: 1,
      icon: <BsBroadcastPin />,
      title: " Live Scrolling ",
      description: " We Scroll Your Add 24H as your Time Period ",
    },
    {
      id: 2,
      icon: <BsMegaphone />,
      title: " Advertisement Making  ",
      description: " We Have Expert Team To Create Your Add  ",
    },
    {
      id: 3,
      icon: <BsGraphUp />,
      title: "Better Reach ",
      description: " Our News is Fully Seo friendly and also your Add ",
    },
    {
      id: 4,
      icon: <BsPeople />,
      title: "Focused Targeting ",
      description: " We Focused on your targeting Audion's. ",
    },
  ],
  newsService: [
    {
      id: 1,
      icon: <BsBadgeHd />,
      title: " Full HD live ",
      description: " We Scroll Your Add 24H as your Time Period ",
    },
    {
      id: 2,
      icon: <BsPhone />,
      title: " Mobile Support  ",
      description: " We Have Expert Team To Create Your Add  ",
    },
    {
      id: 3,
      icon: <BsBadgeAd />,
      title: "Advertisement free ",
      description: " Our News is Fully Seo friendly and also your Add ",
    },
    {
      id: 4,
      icon: <BsHddNetwork />,
      title: "Hdd Network ",
      description: " We Focused on your targeting Audion's. ",
    },
  ],
};

export default ServicesData;
